export default __webpack_public_path__ + "static/media/Face-gray.047a10bc.svg";